module.exports = __webpack_public_path__ + "static/media/neville_ellis.7370a8f1.pdf";